import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import { LanguageProvider } from './context/LanguageContext';
import MainLayout from './layouts/MainLayout';
import NotFound from './pages/NotFound';
import { SkeletonCard } from './components/ui/Skeleton';

// Lazy loading para mejor rendimiento
const Home = lazy(() => import('./pages/Home'));
const About = lazy(() => import('./pages/About'));
const Contact = lazy(() => import('./pages/Contact'));
const Privacy = lazy(() => import('./pages/Privacy'));
const Terms = lazy(() => import('./pages/Terms'));

// Loading fallback with skeleton
const LoadingFallback = () => (
  <div style={{ 
    padding: 'var(--spacing-8)',
    maxWidth: '1280px',
    margin: '0 auto'
  }}>
    <SkeletonCard />
    <div style={{ marginTop: 'var(--spacing-6)' }}>
      <SkeletonCard />
    </div>
  </div>
);

function App() {
  return (
    <AppProvider>
      <LanguageProvider>
        <Router
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true
          }}
        >
          <MainLayout>
            <Suspense fallback={<LoadingFallback />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Suspense>
          </MainLayout>
        </Router>
      </LanguageProvider>
    </AppProvider>
  );
}

export default App;
